import posthog from 'posthog-js';

import { isPostHogEnabled } from '@/lib/isStaging';

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

const apiHost =
  process.env.NODE_ENV === 'development'
    ? // Avoid 431s from localhost/dev cookies by not proxying PostHog scripts through Next.
      (process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com')
    : '/ingest';

if (token && isPostHogEnabled()) {
  posthog.init(token, {
    api_host: apiHost,
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    // Error Tracking: $exception events with issue grouping (not custom console_error events).
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: true,
    },
    debug: process.env.NODE_ENV === 'development',
    session_recording: {
      maskAllInputs: true,
      blockSelector: '.ph-no-capture',
    },
  });
}
